"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

function isAssetInLocalStorage(a, b) {
  if (!a) return !1;
  var c = a.filename,
      d = a.lastModified,
      e = a.metaData,
      f = JSON.parse(e),
      g = f.size;
  return c === b.name && g === b.size && d === b.lastModified;
}

var _default = isAssetInLocalStorage;
exports["default"] = _default;